import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "secondaryInput", "row", "submitButton", "reset", "applyVersion"];
  static values = { initial: String }

  connect() { }

  toggleSubmitVisibility() {
    this.inputTargets.concat(this.secondaryInputTargets).forEach(input => {
      this.setVisibilityAndHighlight(input.value != this.initialValue);
    });
  }

  resetValues() {
    this.inputTargets.concat(this.secondaryInputTargets).forEach(input => { input.value = this.initialValue; });
    this.setVisibilityAndHighlight(false);
  }

  setVisibilityAndHighlight(active) {
    this.setNodeVisibility(this.submitButtonTarget, active);
    this.setNodeVisibility(this.resetTarget, active);
    this.setHighlightRow(this.rowTarget, active)
  }

  setNodeVisibility(node, visible) {
    node.classList.remove("btn", "hidden");
    node.classList.add(visible ? "btn" : "hidden");
  }

  setHighlightRow(row, highlighted) {
    this.rowTarget.classList.remove("bg-white", "bg-gray-100");
    this.rowTarget.classList.add(highlighted ? "bg-gray-100" : "bg-white");
  }

  applyVersion() {
    let v = this.applyVersionTarget.value,
      form = this.applyVersionTarget.form,
      hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', 'apply_version');
    hiddenField.setAttribute('value', v);

    form.appendChild(hiddenField);
    this.inputTargets.concat(this.secondaryInputTargets).forEach(input => { input.disabled = true; });

    this.submitButtonTarget.click();
  }
}